<button
  [type]="type"
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  (click)="onClick()"
>
  <!-- Loading Spinner -->
  <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>

  <!-- Icon -->
  <i *ngIf="icon && !loading" [class]="'bi ' + icon + ' me-2'"></i>

  <!-- Label -->
  <span>{{ label }}</span>
</button>
